import { createSlice } from "@reduxjs/toolkit";
import { getLocations } from "./locationAction";

const initialState = {
  loading: false,
  error: null,
  success: false,
  possibleLocations: [],
};

const locationSlice = createSlice({
  name: "locations",
  initialState,
  reducers: {
    resetLocations: (state) => {
      state.possibleLocations = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLocations.pending, (state) => {
        state.loading = true;
      })
      .addCase(getLocations.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.possibleLocations = payload;
        state.error = null;
      })
      .addCase(getLocations.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });
  },
});

export const { resetLocations } = locationSlice.actions;

export default locationSlice.reducer;
